import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, Box, IconButton, DialogProps } from '@material-ui/core'

import Icon from 'common/components/base/Icon'
import Button from 'common/components/base/Button'
import Success from './Sucess'
import Failed from './Failed'

import useStyles from './useStyles'

export interface HandoverDialogResultProps
  extends Omit<
    DialogProps,
    | 'fullWidth'
    | 'naxWidth'
    | 'PaperProps'
    | 'classes'
    | 'onClose'
    | 'disableBackdropClick'
    | 'disableEnforceFocus'
  > {
  shipment: any
  error: boolean
  onClose: (open?: boolean) => void
  onReprint?: () => void
}

const HandoverDialogResult: React.FC<HandoverDialogResultProps> = ({
  shipment,
  error,
  open,
  onClose,
  onReprint,
  ...others
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Dialog
      disableEnforceFocus
      fullWidth
      maxWidth="md"
      open={open}
      PaperProps={{ elevation: 0 }}
      classes={{ paper: classes.paper }}
      onClose={() => onClose(false)}
      {...others}
    >
      <div className="absolute top-4 right-4 h-16 w-16">
        <IconButton onClick={() => onClose(false)}>
          <Icon name="close" />
        </IconButton>
      </div>
      {error ? <Failed /> : <Success shipment={shipment} />}
      {!error && onReprint && (
        <div className="absolute bottom-4 right-4">
          <Button
            color="white"
            startIcon={<Icon name="print" fill="currentColor" />}
            onClick={onReprint}
          >
            {t('PRINT_AGAIN')}
          </Button>
        </div>
      )}
    </Dialog>
  )
}

export default HandoverDialogResult
